var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1832_14377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1832_14377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 49.9998C45.4167 49.9998 41.493 48.3679 38.2292 45.104C34.9653 41.8401 33.3333 37.9165 33.3333 33.3332C33.3333 28.7498 34.9653 24.8262 38.2292 21.5623C41.493 18.2984 45.4167 16.6665 50 16.6665C54.5833 16.6665 58.5069 18.2984 61.7708 21.5623C65.0347 24.8262 66.6667 28.7498 66.6667 33.3332C66.6667 37.9165 65.0347 41.8401 61.7708 45.104C58.5069 48.3679 54.5833 49.9998 50 49.9998ZM16.6667 83.3332V71.6665C16.6667 69.3054 17.2743 67.1353 18.4896 65.1561C19.7049 63.1769 21.3194 61.6665 23.3333 60.6248C27.6389 58.4721 32.0139 56.8575 36.4583 55.7811C40.9028 54.7047 45.4167 54.1665 50 54.1665C54.5833 54.1665 59.0972 54.7047 63.5417 55.7811C67.9861 56.8575 72.3611 58.4721 76.6667 60.6248C78.6806 61.6665 80.2951 63.1769 81.5104 65.1561C82.7257 67.1353 83.3333 69.3054 83.3333 71.6665V83.3332H16.6667ZM25 74.9998H75V71.6665C75 70.9026 74.809 70.2082 74.4271 69.5832C74.0451 68.9582 73.5417 68.4721 72.9167 68.1248C69.1667 66.2498 65.3819 64.8436 61.5625 63.9061C57.743 62.9686 53.8889 62.4998 50 62.4998C46.1111 62.4998 42.2569 62.9686 38.4375 63.9061C34.618 64.8436 30.8333 66.2498 27.0833 68.1248C26.4583 68.4721 25.9549 68.9582 25.5729 69.5832C25.191 70.2082 25 70.9026 25 71.6665V74.9998ZM50 41.6665C52.2917 41.6665 54.2535 40.8505 55.8854 39.2186C57.5174 37.5866 58.3333 35.6248 58.3333 33.3332C58.3333 31.0415 57.5174 29.0797 55.8854 27.4478C54.2535 25.8158 52.2917 24.9998 50 24.9998C47.7083 24.9998 45.7465 25.8158 44.1146 27.4478C42.4826 29.0797 41.6667 31.0415 41.6667 33.3332C41.6667 35.6248 42.4826 37.5866 44.1146 39.2186C45.7465 40.8505 47.7083 41.6665 50 41.6665Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/Student.4d2d278c0eb7a3de2842802831cb24a1.svg";
export { ForwardRef as ReactComponent };